/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BusinessType = {
    CORPORATE: 'CORPORATE',
    RESTAURANT: 'RESTAURANT'
} as const;
export type BusinessType = typeof BusinessType[keyof typeof BusinessType];


export function instanceOfBusinessType(value: any): boolean {
    for (const key in BusinessType) {
        if (Object.prototype.hasOwnProperty.call(BusinessType, key)) {
            if (BusinessType[key as keyof typeof BusinessType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BusinessTypeFromJSON(json: any): BusinessType {
    return BusinessTypeFromJSONTyped(json, false);
}

export function BusinessTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessType {
    return json as BusinessType;
}

export function BusinessTypeToJSON(value?: BusinessType | null): any {
    return value as any;
}

export function BusinessTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): BusinessType {
    return value as BusinessType;
}

